module.exports = __webpack_public_path__ + "static/media/cat.8f869b25.svg";